import { createContext } from 'react';
import { noOp } from '../services/noOp';
import { Action } from '../types/reducer/Action';

export const DispatchContext = createContext<React.Dispatch<Action>>(noOp);
